import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const PDIRejectedDialog = ({ open, onClose, onSubmit }) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [pdiDoneBy, setPdiDoneBy] = useState("");
  const [errors, setErrors] = useState({
    rejectionReason: false,
    pdiDoneBy: false,
  });

  const handleClose = () => {
    // Reset all states when closing
    setRejectionReason("");
    setPdiDoneBy("");
    setErrors({
      rejectionReason: false,
      pdiDoneBy: false,
    });
    onClose();
  };

  const handleSubmit = () => {
    // Validate fields
    const hasRejectionReasonError = !rejectionReason.trim();
    const hasPdiDoneByError = !pdiDoneBy.trim();

    const newErrors = {
      rejectionReason: hasRejectionReasonError,
      pdiDoneBy: hasPdiDoneByError,
    };

    setErrors(newErrors);

    // If any field is empty, return without submitting
    if (hasRejectionReasonError || hasPdiDoneByError) {
      return;
    }

    onSubmit(rejectionReason, pdiDoneBy);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "600px",
        },
      }}
    >
      <DialogTitle>PDI Details</DialogTitle>
      <DialogContent>
        {/* PDI Rejected By Field */}
        <div className="mb-4">
          <Typography
            component="label"
            variant="body2"
            sx={{
              display: "block",
              fontWeight: 500,
              mb: 1,
              color: errors.pdiDoneBy ? "error.main" : "text.secondary",
            }}
          >
            PDI Rejected By *
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            type="text"
            fullWidth
            value={pdiDoneBy}
            onChange={(e) => {
              setPdiDoneBy(e.target.value);
              if (errors.pdiDoneBy && e.target.value.trim()) {
                setErrors({ ...errors, pdiDoneBy: false });
              }
            }}
            error={errors.pdiDoneBy}
            helperText={
              errors.pdiDoneBy && (
                <Typography variant="caption" sx={{ color: "error.main" }}>
                  This field is required
                </Typography>
              )
            }
            required
            placeholder="Enter Your Name"
            InputLabelProps={{ shrink: false }}
            inputProps={{ "aria-label": "PDI Rejected By" }}
            sx={{
              "& .MuiInputLabel-root": {
                transform: "none",
                position: "relative",
                marginBottom: "4px",
                fontSize: "0.875rem",
              },
              "& .MuiInputBase-input::placeholder": {
                opacity: 1,
                color: "text.disabled",
              },
            }}
          />
        </div>

        {/* PDI Rejection Reason Field */}
        <div className="mb-4">
          <Typography
            component="label"
            variant="body2"
            sx={{
              display: "block",
              fontWeight: 500,
              mb: 1,
              color: errors.rejectionReason ? "error.main" : "text.secondary",
            }}
          >
            PDI Rejection Reason *
          </Typography>
          <TextField
            margin="dense"
            type="text"
            fullWidth
            value={rejectionReason}
            onChange={(e) => {
              setRejectionReason(e.target.value);
              if (errors.rejectionReason && e.target.value.trim()) {
                setErrors({ ...errors, rejectionReason: false });
              }
            }}
            error={errors.rejectionReason}
            helperText={
              errors.rejectionReason && (
                <Typography variant="caption" sx={{ color: "error.main" }}>
                  This field is required
                </Typography>
              )
            }
            required
            placeholder="Enter reason for PDI rejection"
            InputLabelProps={{ shrink: false }}
            inputProps={{ "aria-label": "PDI Rejection Reason" }}
            sx={{
              "& .MuiInputLabel-root": {
                transform: "none",
                position: "relative",
                marginBottom: "4px",
                fontSize: "0.875rem",
              },
              "& .MuiInputBase-input::placeholder": {
                opacity: 1,
                color: "text.disabled",
              },
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex items-center gap-3 justify-end">
          <GlobalButton variant="secondary" size="medium" onClick={handleClose}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="primary" size="medium" onClick={handleSubmit}>
            Rejected
          </GlobalButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default PDIRejectedDialog;
